var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: " M 10.8 11.1 Q 11.75 12 13.05 12 14.35 12 15.25 11.1 16.15 10.15 16.15 8.85 16.15 7.6 15.25 6.65 14.35 5.75 13.05 5.75 11.75 5.75 10.8 6.65 9.9 7.55 9.9 8.85 9.9 10.15 10.8 11.1 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.65,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 19.3 2.6 L 23.45 2.6 23.45 6.8 M 19.3 23.45 L 23.45 23.45 23.45 19.25 M 13.05 12 Q 14.35 12 15.25 11.1 16.15 10.15 16.15 8.85 16.15 7.6 15.25 6.65 14.35 5.75 13.05 5.75 11.75 5.75 10.8 6.65 9.9 7.55 9.9 8.85 9.9 10.15 10.8 11.1 11.75 12 13.05 12 Z M 6.8 2.6 L 2.6 2.6 2.6 6.8 M 19.3 19.25 Q 19.3 16.65 17.45 14.85 15.65 13 13.05 13 10.45 13 8.6 14.85 6.8 16.65 6.8 19.25 M 6.8 23.45 L 2.6 23.45 2.6 19.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileUserProfile);
export default __webpack_public_path__ + "static/media/icon-profile-user-profile.a242133cd08407bcdab65774ac92ea5e.svg";
export { ForwardRef as ReactComponent };